var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"hide-default-footer":"","disable-sort":"","headers":_vm.headers(),"items":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }